module.exports = __webpack_public_path__ + "asset/image/fan-on-c369.svg";